import { defineAgenda, param } from '@/shared/navigation/core';
import type { ParamCodec } from '@/shared/navigation/core';

/**
 * Codec pro dictionary parametrů (form params) serializovaný jako JSON.
 * Není to obecný `param.json()` v shared, protože ho jinde nepotřebujeme;
 * pokud vznikne další případ, povýšit do paramCodec.ts.
 */
const recordCodec: ParamCodec<Record<string, unknown>> = {
  encode: (v) => JSON.stringify(v),
  decode: (r) => {
    if (!r) return {};
    try {
      const parsed = JSON.parse(r);
      return typeof parsed === 'object' && parsed !== null
        ? (parsed as Record<string, unknown>)
        : {};
    } catch {
      return {};
    }
  },
};

/**
 * Legacy-form agenda — hostuje jeden Magic formulář v iframu (single-form mode).
 *
 * Agenda je generická pro libovolný legacy formulář:
 * - `formGlobalName` — Magic Form GlobalName (např. `Organization.Edit`, `BusinessCase.List`)
 * - `formParams` — dictionary parametrů předávaných do Magic iframu (např. `EditedObjectID`)
 *
 * Každá instance agendy = vlastní Magic iframe (vlastní Magic session a formulář).
 * Stack řídí Phoenix kernel; každá další navigace probublá z Magicu jako nová instance této agendy.
 */
export const legacyFormAgenda = defineAgenda({
  id: 'app.legacy-form',
  path: 'app/legacy-form',
  open: {
    formGlobalName: param.string(),
    formParams: param.custom(recordCodec).optional(),
  },
  state: {},
  title: (params) => (params.formGlobalName as string | undefined) ?? 'Legacy form',
  icon: 'window',
  // Okenní framework: obsah je Magic2G iframe → typový chip „M", titulek/akce se „vycucnou".
  presentationHints: { windowKind: 'legacy' },
});
